// CallToActionOne component - Converted from components/CallToActionOne.vue
// Call to action section with background image
import React from 'react';
import bgImage from '../assets/images/resources/Section.png';

const CallToActionOne: React.FC = () => {
  return (
    <section 
      className="cta-one" 
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="cta_one_content" >
              <h1 style={{fontSize: '3rem'}}>
                VOUS FOURNIR DES PRODUITS DE LA
                <br />
                PLUS HAUTE QUALITÉ QUI RÉPONDENT À
                <br />
                VOS ATTENTES
              </h1>
              <p></p>
              <div className="cta_one__button-block">
                <a href="/about" className="thm-btn cta_one__btn">
                  Découvrez-en plus
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToActionOne;
